import { Lead } from 'models/Lead';
import { Listing } from 'models/Listing';
import { NdaStatus } from 'models/Nda';
import { User } from 'models/User';
import { ObjectValues } from 'types';

export type TableHeaderKey = keyof BossModeTrack;

export type TableHeader = {
  key: TableHeaderKey;
  label: string;
  sortValue?: string;
};

const BOSS_MODE_TRACK_EVENTS = {
  DRAFT_LISTING: 'draft_listing',
  EDIT_LISTING: 'edit_listing',
  ADD_NOTES: 'add_notes',
  SEND_MESSAGE: 'send_message',
  CHANGE_NDA_STATUS: 'change_nda_status',
} as const;

type BossModeTrackEvents = ObjectValues<typeof BOSS_MODE_TRACK_EVENTS>;

export const BOSS_MODE_TRACK_EVENTS_LABEL: Record<BossModeTrackEvents, string> =
  {
    draft_listing: 'draftListing',
    edit_listing: 'editListing',
    add_notes: 'addNote',
    send_message: 'sendMessage',
    change_nda_status: 'changeNdaStatus',
  };

export type BossModeTrack = {
  _id: string;

  eventType: BossModeTrackEvents;

  //user who trigerrs event
  userId: string;
  user: Partial<User> | null;

  listingId: string;
  listing: Partial<Listing> | null;

  leadId: string;
  lead: Partial<Lead> | null;

  //for send_message event
  receiverUserId: string;
  receiver: Partial<User> | null;

  //for change_nda_status event
  previousNdaStatus: NdaStatus;
  newNdaStatus: NdaStatus;

  createdAt: Date;
};
